module.exports = __webpack_public_path__ + "img/test_Icon13.0e0382f7.png";